import { FC, useRef } from 'react'
import styled from 'styled-components'
import useScrollOpacityChanger from '@hooks/useScrollOpacityChanger'
import { Container, Row, Col } from '@mch-group/uikit-components'
import { Media, MediaContextProvider } from '@responsive'
import CuratorPick from '@components/CuratorPick'
import GalleryName from '../components/GalleryName'
import { useModuleContext } from '../contexts/module'
import { convertHexToRgba } from '@utils/cssHelpers'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'

const Content: FC = () => {
  const backgroundEl = useRef<HTMLDivElement | null>(null)
  const {
    state: { artworkInformation, labels }
  } = useModuleContext()
  const { imageSrc, curator, curatorPickLabel, showEnded, isPortrait, textColorClass } = artworkInformation || {}
  const altText = `${artworkInformation?.artworkInfo?.displayName} ${labels?.AltTags?.altTagBy} ${artworkInformation?.artworkInfo?.artistName} ${artworkInformation?.artworkInfo?.year ? `(${artworkInformation?.artworkInfo?.year})` : ''}`

  useScrollOpacityChanger({ el: backgroundEl, breakpoint: 1024, changeSpeed: 3 })
  // const overlayColor = 'black' // FIX
  const gradientColor = `rgba(${convertHexToRgba(tokens.color.light.base.neutrals[1000].value, tokens.opacity[30].value)})`
  return (
    <OuterDiv>
      <MediaContextProvider>
        <Media greaterThanOrEqual='tablet'>
          <DivBackgroungImage
            $imageSrc={imageSrc}
            $gradientColor={gradientColor}
            className={isPortrait ? 'bg-contain' : 'bg-cover'}
            role='img'
            aria-label={altText}
          />
        </Media>
        <Media lessThan='tablet'>
          <DivBackgroungImage
            $imageSrc={imageSrc}
            $gradientColor={gradientColor}
            className={isPortrait ? 'bg-portrait-mobile' : 'bg-landscape-mobile'}
            role='img'
            aria-label={altText}
          />
        </Media>
      </MediaContextProvider>

      <BackgroundColorChangingDiv ref={backgroundEl} />
      <TextAtTop className='px-5 px-lg-8 px-md-7'>
        <Row>
          <Col className='mt-0 offset-lg-1 text-start z-1'>
            {curator &&
              <h4 className={textColorClass}>
                <CuratorPick
                  curatorName={curator.fullName}
                  profileUrl={curator.profileUrl}
                  curatorPickLabel={curatorPickLabel}
                  isCuratorBannerClickable={!showEnded}
                />
              </h4>}
            <GalleryName />
          </Col>
        </Row>
      </TextAtTop>
    </OuterDiv>
  )
}

const OuterDiv = styled.div`
  width: 100%;

  @media (min-width: ${global.uikitVars.breakpointMd}) {
    height: calc(100vh - 66px);
  }
`

const TextAtTop = styled(Container)`
  top: 160px;
  position: absolute;

  .z-1 {
    z-index: 1;
  }

  @media (min-width: ${global.uikitVars.breakpointMd}) {
    position: relative;
    top: 80px;
  }
`

// TODO: Move this one and similars to a reusable component. It only differens in bkgr-size css prop
const DivBackgroungImage = styled.div<any>`
  &.bg-portrait-mobile {
    background-size: 52vh;
  }

  &.bg-landscape-mobile {
    background-size: 103vh;
  }

  &.bg-cover {
    background-size: cover;
  }

  &.bg-contain {
    background-size: contain;
  }

  ${({ $imageSrc, $gradientColor }) =>
    $imageSrc && `background: linear-gradient(0deg, ${$gradientColor}, ${$gradientColor}),  url(${$imageSrc}) top center no-repeat`};
  /** 150px is the size of the minimized header */
  height: 58vh;
  background-attachment: fixed;
  width: 100%;
  z-index: -1;

  @media (min-width: 0) {
    background-position: center 104px;
    background-size: 73vh;
  }

  @media (min-width: ${global.uikitVars.breakpointMd}) {
    position: fixed;
    height: calc(100vh - 81px);
  }
`

const BackgroundColorChangingDiv = styled.div<any>`
  height: calc(100vh - 81px);
  position: fixed;
  width: 100%;
  z-index: -1;

  @media (min-width: ${global.uikitVars.breakpointMd}) {
    position: fixed;
  }
`

export default Content
